import { z } from 'zod'
import { TRAINING_TYPES } from '../constants/training-enums'
import { SettableNotificationChannelSchema } from './notification-channel'

export const CreateTrainingSchema = z.object({
  title: z
    .string()
    .min(1, { message: '研修タイトルを入力してください。' })
    .max(200, { message: '研修タイトルは200文字以内で入力してください。' }),
  description: z
    .string()
    .max(5000, { message: '研修説明は5000文字以内で入力してください。' })
    .optional()
    .nullable(),
  trainingType: z.enum(TRAINING_TYPES, { message: '研修タイプを選択してください。' }),
  category: z.string().max(200).optional().nullable(),
  tags: z.array(z.string().max(100)).max(20).optional().default([]),
  capacity: z
    .number()
    .int()
    .min(1, { message: '定員は1以上で設定してください。' })
    .optional()
    .nullable(),
  standardDurationHours: z
    .number()
    .min(0.5, { message: '標準受講時間は0.5時間以上で設定してください。' })
    .optional()
    .nullable(),
  guideFileUrl: z.preprocess(
    (v) => (v === '' ? undefined : v),
    z.string().url({ message: '有効なURLを入力してください。' }).optional().nullable(),
  ),
  notificationChannel: SettableNotificationChannelSchema.optional().nullable(),
  hrContactEmail: z.preprocess(
    (v) => (v === '' ? undefined : v),
    z.string().email({ message: '有効なメールアドレスを入力してください。' }).optional().nullable(),
  ),
  skillCheckNote: z
    .string()
    .max(500, { message: 'スキルチェックの補足は500文字以内で入力してください。' })
    .optional()
    .nullable(),
})

export const UpdateTrainingSchema = CreateTrainingSchema.partial().extend({
  isPublished: z.boolean().optional(),
})

export const CreateTrainingScheduleSchema = z.object({
  scheduleDate: z
    .string()
    .or(z.date())
    .transform((v) => (typeof v === 'string' ? new Date(v) : v)),
  endDate: z
    .string()
    .or(z.date())
    .optional()
    .nullable()
    .transform((v) => (v == null ? v : typeof v === 'string' ? new Date(v) : v)),
  location: z.string().max(500).optional().nullable(),
  dayNumber: z.number().int().min(1, { message: 'Day番号は1以上で設定してください。' }),
})

export const TrainingFilterSchema = z.object({
  trainingType: z.enum(TRAINING_TYPES).optional(),
  category: z.string().optional(),
  isPublished: z.boolean().optional(),
  search: z.string().optional(),
})

export type CreateTrainingInput = z.infer<typeof CreateTrainingSchema>
export type UpdateTrainingInput = z.infer<typeof UpdateTrainingSchema>
export type CreateTrainingScheduleInput = z.infer<typeof CreateTrainingScheduleSchema>
export type TrainingFilterInput = z.infer<typeof TrainingFilterSchema>
